import { ProductType } from '../config/ProductData';
import { GameConfig } from '../config/GameConfig';

export class ProductionState {
  private wipCount: number = 0;
  private finishedProducts: Record<ProductType, number> = {
    [ProductType.ToyCar]: 0,
    [ProductType.Robot]: 0,
    [ProductType.LuxuryDoll]: 0,
  };
  private selectedProduct: ProductType = ProductType.ToyCar;
  private machineALevel: number = 0;
  private machineBLevel: number = 0;

  get WIPCount(): number { return this.wipCount; }
  get SelectedProduct(): ProductType { return this.selectedProduct; }
  get FinishedProducts(): Record<ProductType, number> { return this.finishedProducts; }
  get MachineALevel(): number { return this.machineALevel; }
  get MachineBLevel(): number { return this.machineBLevel; }

  getMachineADuration(): number {
    const mult = this.machineALevel > 0 ? GameConfig.machineAUpgradeSpeed[this.machineALevel - 1] : 1;
    return GameConfig.machineAProcessTime * mult;
  }

  getMachineBDuration(): number {
    const mult = this.machineBLevel > 0 ? GameConfig.machineBUpgradeSpeed[this.machineBLevel - 1] : 1;
    return GameConfig.machineBProcessTime * mult;
  }

  canUpgradeMachineA(credits: number): boolean {
    if (this.machineALevel >= 2) return false;
    return credits >= GameConfig.machineAUpgradeCosts[this.machineALevel];
  }

  canUpgradeMachineB(credits: number): boolean {
    if (this.machineBLevel >= 2) return false;
    return credits >= GameConfig.machineBUpgradeCosts[this.machineBLevel];
  }

  upgradeMachineA(): number {
    const cost = GameConfig.machineAUpgradeCosts[this.machineALevel];
    this.machineALevel++;
    return cost;
  }

  upgradeMachineB(): number {
    const cost = GameConfig.machineBUpgradeCosts[this.machineBLevel];
    this.machineBLevel++;
    return cost;
  }

  setSelectedProduct(type: ProductType): void {
    this.selectedProduct = type;
  }

  addWIP(): void { this.wipCount++; }

  consumeWIP(): boolean {
    if (this.wipCount > 0) { this.wipCount--; return true; }
    return false;
  }

  addFinished(product: ProductType): void {
    this.finishedProducts[product]++;
  }

  consumeFinished(product: ProductType): boolean {
    if (this.finishedProducts[product] > 0) {
      this.finishedProducts[product]--;
      return true;
    }
    return false;
  }

  hasFinished(product: ProductType): boolean {
    return this.finishedProducts[product] > 0;
  }

  totalFinished(): number {
    return this.finishedProducts[ProductType.ToyCar]
      + this.finishedProducts[ProductType.Robot]
      + this.finishedProducts[ProductType.LuxuryDoll];
  }

  reset(): void {
    this.wipCount = 0;
    this.finishedProducts = {
      [ProductType.ToyCar]: 0,
      [ProductType.Robot]: 0,
      [ProductType.LuxuryDoll]: 0,
    };
    this.selectedProduct = ProductType.ToyCar;
    this.machineALevel = 0;
    this.machineBLevel = 0;
  }
}

export const productionState = new ProductionState();
